import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
// import { DevTools, tenants } from '@ta-interaktiv/microfrontend-devtools'
// import tenants from 'Constants/tenants'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  import('@ta-interaktiv/microfrontend-devtools').then((module) => {
    const { DevTools } = module
    const DevToolAppWrapper = () => {
      // I need to pass the properties prop to the App before passing it to DevTools
      // dynamic import of DevTools

      App.defaultProps = {
        properties: {
          component: 'FootnotesBox',
        },
      }
      return <DevTools MicroFrontend={App} />
    }
    const root = createRoot(document.getElementById('root')!)
    root.render(
      <React.StrictMode>
        <DevToolAppWrapper />
      </React.StrictMode>
    )
  })
}
